import Swiper from 'swiper/dist/js/swiper.js';

new Swiper( '.js-storeImage', {
  autoplay: {
    delay: 3000,
    waitForTransition: false,
    disableOnInteraction: false,
  },
  loop: true,
  effect: 'fade',
  fade: {
    crossFade: true,
  },
  pagination: {
    el: '.swiper-pagination', // ページネーションを表示するセレクタ
    clickable: true,
  },
  slideToClickedSlide: true,
});

const initMap = () => {

  if (document.getElementById('storeMap') !== null) {

    const newStoreMap = (storeX,storeY) => {
      const latLng = new google.maps.LatLng(storeX, storeY);
      const map = new google.maps.Map(
        document.getElementById('storeMap'),
        {
          zoom: 17,  // 拡大率
          center: latLng,
          scrollwheel: false,  // マウスホイールで拡縮しなくなる
        },
      );
      new google.maps.Marker({
        position: latLng,
        map: map,
        icon: '/assets/images/store/icon_map_pin.png',
      });

      const mapStyle = [
        {
          stylers: [
            { 'saturation': -100 },
            { 'gamma': 0.8 },
            { 'lightness': 4 },
            { 'visibility': 'on' },
          ],
        },
        {
          featureType: 'landscape.natural',
          stylers: [
            { 'visibility': 'on' },
            { 'color': '#5dff00' },
            { 'gamma': 4.97 },
            { 'lightness': -5 },
            { 'saturation': 100 },
          ],
        },
      ];

      const mapType = new google.maps.StyledMapType(mapStyle);
      map.mapTypes.set('GrayScaleMap', mapType);
      map.setMapTypeId('GrayScaleMap');
    }


    if (document.getElementById('storeMapShibuya') !== null) {
      newStoreMap(35.66266, 139.7000371);
    }else if(document.getElementById('storeMapTakasaki') !== null) {
      newStoreMap(36.3245139,139.0066768);
    }else if(document.getElementById('storeMapShinsaibashi') !== null) {
      newStoreMap(34.6732672, 135.4977922);
    }else if(document.getElementById('storeMapKyoto') !== null) {
      newStoreMap(35.008006, 135.767302);
    }else if(document.getElementById('storeMapFukuoka') !== null) {
      newStoreMap(33.590824, 130.400079);
    }
  }
};

window.addEventListener('load', initMap);



// WEBPACK FOOTER //
// ./src/js/store.js